export enum BackendSettings {
    PageSaving = "User.PageSaving",
    LanguageChoice = "Language",
    EmbedConsent = "Pref.Consent.EmbeddedContent",
    Grades = "Pref.Notification.Grades",
    Feedback = "Pref.Notification.Feedback",
    Comments = "Pref.Notification.Comments",
    Updated = "Pref.Notification.Updated",
    Shares = "Pref.Notification.Shares",
    AtlasReceipts = "Pref.Notification.AtlasReceipts",
    NotificationTime = "Pref.Notification.Time",
    NotificationFrequency = "Pref.Notification.Frequency"
}
